import { t } from 'i18next';

import { HeaderModalOptions } from 'coreOld/constants';

export const getModalInfoByType = (type?: HeaderModalOptions) => {
  switch (type) {
    case HeaderModalOptions.SET_UP_ACCOUNT:
      return {
        title: t('labelSetUpNewPassword'),
        submitBtnLabel: t('buttonLabelSetUpAccount'),
      };
    default:
      return {
        title: t('titleCreatePassword'),
        submitBtnLabel: t('buttonLabelSubmit'),
      };
  }
};
